<template>
	<div>
		<div
			class="modal fade"
			id="salesSummary"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:260px;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Summary View</h5>
						<button type="button" class="close" data-dismiss="modal" @click = "resetAction()">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px">
						<div class="table-responsive">
							<table class="table">
								<thead>
									<tr>
										<th>KPIs</th>
										<th>Reported</th>
										<th>Last Year</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th></th>
										<th></th>
										<th></th>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "resetAction()">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "SalesSummary",
		components: {
		},
		mounted() {
			//this.openCampaignGroup();
		},
		props:[],
		data() {
			return {

			};
		},
		watch: {},
		methods: {
			resetAction(){
				this.$emit("resetAction")
			}
		}

	};
</script>
<style lang="scss">
</style>
